<template>
    <!-- 手机端 上下结构 文字+图片 -->
    <div class="itBox">
        <div class="textBox">
            <div class="title">{{ list.title }}</div>
            <div class="en">{{ list.en }}</div>
            <div class="pp">{{ list.pp }}</div>
        </div>
        <div class="imgBox">
            <img :src="list.img" alt="">
        </div>
    </div>
            

    
</template>

<script>
export default {
    props:["list"]
}
</script>

<style lang="scss" scoped>
.itBox{
    margin-bottom: vp(40);

    .imgBox{
        width: vp(683);
        height: vp(438);

        img{
            width: 100%;
            height: 100%;
        }
    }

    .textBox{
        
        .title{
            font-size: vp(32);
            color: $blue096;
        }

        .en{
            margin-bottom: vp(24);
            font-size: vp(24);
            color: $font99;
        }

        .pp{
            margin-bottom: vp(30);
            font-size: vp(30);
            text-align: left;
            text-indent: 2em;
            line-height: 1.8;
            color: $font23;   
        }
    }
}



</style>